import { render, staticRenderFns } from "./Shorts.vue?vue&type=template&id=8a943b00&scoped=true"
import script from "./Shorts.vue?vue&type=script&lang=js"
export * from "./Shorts.vue?vue&type=script&lang=js"
import style0 from "./Shorts.vue?vue&type=style&index=0&id=8a943b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a943b00",
  null
  
)

export default component.exports